import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import Logo from './Logo';

const SOCIALS = [
  {
    name: 'GitHub',
    url: 'https://github.com/Erkan3034',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
      </svg>
    ),
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/erkanturgut1205',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    name: 'X',
    url: 'https://x.com/Erkan_0630',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    name: 'Email',
    url: 'mailto:turguterkan55@gmail.com',
    icon: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
      </svg>
    ),
  },
];

const Footer = () => {
  const year = new Date().getFullYear();
  const { t } = useLanguage();

  const NAV_LINKS = [
    { key: 'nav.home', path: '/' },
    { key: 'nav.about', path: '/about' },
    { key: 'nav.experience', path: '/experience' },
    { key: 'nav.projects', path: '/projects' },
    { key: 'nav.blog', path: '/blog' },
    { key: 'nav.certificates', path: '/certificates' },
    { key: 'nav.contact', path: '/contact' },
  ];

  return (
    <footer className="bg-canvas border-t border-white/[0.06]">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-8 md:px-12 lg:px-16 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4" aria-label="Erkan Turgut — Ana Sayfa">
              <Logo />
            </Link>
            <p className="text-zinc-400 text-sm font-body leading-relaxed max-w-xs">
              {t('footer.description')}
            </p>
            <div className="flex items-center gap-1 mt-5">
              {SOCIALS.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target={s.url.startsWith('mailto') ? '_self' : '_blank'}
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  className="w-8 h-8 flex items-center justify-center rounded-lg text-zinc-500 hover:text-zinc-300 hover:bg-white/[0.05] transition-all duration-150 cursor-pointer"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h2 className="text-white text-sm font-semibold font-body mb-4 tracking-wide">{t('footer.pages')}</h2>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.path}
                    className="text-zinc-400 hover:text-zinc-300 text-sm font-body transition-colors duration-150"
                  >
                    {t(link.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h2 className="text-white text-sm font-semibold font-body mb-4 tracking-wide">{t('footer.contact')}</h2>
            <ul className="space-y-2.5">
              <li>
                <a href="mailto:turguterkan55@gmail.com"
                  className="text-zinc-400 hover:text-zinc-300 text-sm font-body transition-colors duration-150 break-all">
                  turguterkan55@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-zinc-400 text-sm font-body">
                <svg className="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
                {t('footer.locationValue')}
              </li>
              <li>
                <span className="inline-flex items-center gap-1.5 text-emerald-400 text-sm font-body">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                  {t('footer.openToWork')}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/[0.06] mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-zinc-500 text-xs font-body">
            © {year} Erkan Turgut. {t('footer.rights')}
            {/* Statik sayfa (scripts/generate-seo.js üretir); router dışında, tam yükleme ile açılır */}
            <a href="/site-haritasi/" className="ml-3 hover:text-zinc-300 transition-colors">{t('footer.sitemap')}</a>
            <Link to="/gizlilik" className="ml-3 hover:text-zinc-300 transition-colors">{t('footer.privacy')}</Link>
          </p>
          <p className="text-zinc-500 text-xs font-body italic text-center">
            Simplicity is prerequisite for reliability — Edsger W. Dijkstra
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
